import { IconButton, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import LambdaIcon from '../../../assets/aws/lambda.svg';
import { makeStyles } from '@material-ui/core';
import { LambdaNameInput, LambdaNameInputRef } from './LambdaNameInput';
import { forwardRef } from 'react';

const useStyles = makeStyles(theme => ({
  lambdaHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  nameContainer: {
    flex: 1,
    marginRight: 16,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  lambdaIcon: {
    width: '1.25rem',
    height: '1.25rem',
    flexShrink: 0,
  },
}));

interface LambdaItemHeaderProps {
  name: string;
  onRename: (oldName: string, newName: string) => void;
  onDelete: (name: string) => void;
}

export const LambdaItemHeader = forwardRef<LambdaNameInputRef, LambdaItemHeaderProps>(
  ({ name, onRename, onDelete }, ref) => {
    const classes = useStyles();

    return (
      <div className={classes.lambdaHeader}>
        <div className={classes.nameContainer}>
          <img src={LambdaIcon} alt="Lambda" className={classes.lambdaIcon} />
          <LambdaNameInput ref={ref} currentName={name} onRename={onRename} />
        </div>
        <Tooltip title="Delete Lambda">
          {/* data-ai-anchor: the AI copilot HIGHLIGHTS this button to guide a deletion — it never
              clicks it (the backend plan validator only lets the copilot click navigation controls). */}
          <IconButton
            size="small"
            onClick={() => onDelete(name)}
            color="secondary"
            data-ai-anchor={`lambda.${name}.delete`}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </div>
    );
  },
);

LambdaItemHeader.displayName = 'LambdaItemHeader';
